module.exports = __webpack_public_path__ + "static/media/20180524-LCS-011-12.53d1b325.jpg";